<template>
  <div id="app" class="min-h-screen bg-white">
    <router-view />
    <CookieBanner />
  </div>
</template>

<script setup>
import CookieBanner from '@/components/CookieBanner.vue'
</script>

